import getDevice from './module/getDevice.js'
// import transitions from './module/transitions.js'
// import getBaseUrl from './module/getBaseUrl.js'
import functions from './functions.js' // Activamos functions si no usamos Barba.js

// const baseUrl = getBaseUrl()
// console.log('URL base detectada:', baseUrl)

/* ///////////////////////////////////////////////////////////////////// */
/* /////////////////////////// DEVICE DATA ///////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

const deviceData = getDevice()

/* Ejecutar el getDevice si cambia el tamaño del navegador o rota el dispositivo */
window.addEventListener('resize', getDevice)
window.addEventListener('orientationchange', getDevice)

/* ///////////////////////////////////////////////////////////////////// */
/* /////////////////////////////// EXEC //////////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

document.addEventListener('DOMContentLoaded', function () {
  functions(deviceData)
})
